import { Component, OnInit, NgZone } from '@angular/core';
import { bmxurl } from 'src/globals';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AvailabilityReq, Payment, Customer } from '../../PackageClasses';
import { customer } from 'src/types/customer';
import { booking_returndata } from 'src/types/booking_returndata';
import { MessageService } from 'primeng/api';
import { cExtra } from 'src/types/extra';
import { cPackageExtra } from 'src/types/packageExtra';
import { BusyService } from '../_services/busy.service';
import { admission } from 'src/types/admission';
import { cBookingfee } from 'src/types/bookingfee';
import { paymenttypes_returndata } from 'src/types/paymenttypes_returndata';
import { DomSanitizer } from '@angular/platform-browser';
import { cMembershipDiscountvalidate, cMembershipOpenDiscountvalidate } from 'src/types/discountvailidate';
import { conf_returndata } from 'src/types/conf_returndata';
import { users_returndata } from 'src/types/user_returndata';
import { birthdayanswers, questionanswers } from 'src/types/questionanswers';
import { bookingquestionitem } from 'src/types/bookingquestion';
import { GlobalService } from '../_services/global.service';
import { membership_returndata } from 'src/types/membership_returndata';
import { membershipadmission } from 'src/types/membershipadmissions';
import { membershipsale } from 'src/types/membershipsale';
import { membershipsummary } from 'src/types/membershipsummary';
import { memberadmission } from 'src/types/memberadmissions';
import { v4 as uuidv4  } from 'uuid';
import { aD } from '@fullcalendar/core/internal-common';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-memberships',
  templateUrl: './memberships.component.html',
  styleUrls: ['./memberships.component.css']
})
export class MembershipsComponent implements OnInit {

  //#region  Variables
  id: string;
  BookingComplete: boolean = false;
  packages: any[] = [];
  packages1: any[] = [];
  SelectedPackage: any;
  SelectedResources: any[] = []
  SelectedDate: Date;
  startTimes: any;
  startTimesFiltered: any;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateCustomer: any;
  PaymentTypes: any = [];
  selectedPayment: any;
  packageExtras: cPackageExtra[];
  selectedPackageExtras: cExtra[];

  BookingDateAndTime: string = "";
  BookingPackage: string = "";
  BookingAdmissions: string = "";
  BookingAddress: string = "";
  BookingEmail: string = "";
  BookingMobile: string = "";
  BookingValue: string = "";
  Itinerary: string = "";
  bookingExtras: string = "";

  paymentValueValid: boolean = true;
  paymentTypeValid: boolean = true;
  paymentValueExceededValid: boolean = true;
  paymentDepositValid: boolean = true;
  validPaymentAmount: number = 0;

  AllValid: boolean =true;
  CustomerAllValid: boolean =true;

  PackageAdmissions: admission[];
  SelectedAdmissions: any[] = [];

  PackageHeader: string = "Select a Package";
  CalendarHeader: string = "Select a Date";
  AdmissionHeader: string = "Select your Admissions";
  TimeHeader: string = "Select a Time";
  CustomerHeader: string = "Create a Customer";
  PaymentHeader: string = "Add a Payment";
  ExtrasHeader: string = "Select Extras";
  SelResourceHeader: string = "Please Select";

  packageSelected: Boolean;
  admissionsSelected: Boolean;
  dateSelected: Boolean;
  timeSelected: Boolean;
  customerSelected:Boolean;
  paymentSelected:Boolean;
  extraSelected: Boolean;
  notesSelected: Boolean;
  partyroomsSelected: Boolean;
  bookingQuestionsSelected: Boolean;

  packageActive: Boolean;
  admissionsActive: Boolean;
  dateActive: Boolean;
  timeActive: Boolean;
  customerActive:Boolean;
  paymentActive:Boolean;
  extraActive: Boolean;
  notesActive: Boolean;
  partyroomsActive: Boolean;
  partyroomsVisible: Boolean;
  bookingQuestionsActive: Boolean;

  //Customer
  firstName: string = "";
  lastName: string = "";
  address1: string = "";
  address2: string = "";
  town: string = "";
  postCode: string = "";
  email: string = "";
  mobile: string = "";
  dob: Date = new Date(1900, 1, 1);

  firstNameValid: boolean = true;
  lastNameValid: boolean = true;
  Address1Valid: boolean = true;
  TownValid: boolean = true;
  PostCodeValid: boolean = true;
  EmailValid: boolean = true;
  MobileValid: boolean = true;
  //NewBooking = {} as booking;

  EmailFormatValid: boolean = true;
  MobileFormatValid: boolean = true;

  stateOptions: any[];
  stateOptionsMin: any[];
  statePayOptions: any[];

  ProvideMinimalPersonalData: string = "LIMITED";

  MembershipResponse: any;

  //payment
  paymentAmount: number;
  maxPayment: number;

  searchCriteria: string;
  customersResult: any;

  disgnosticsMode: boolean = true;
  ShowCustomerDetails: boolean = false;

  makeABookingHeader: string = "Make a Booking"
  notes: string;

  SelectedSeletableResource: any[] = [];
  SelectedSeletableResourceBool: boolean[] = [];

  customerSelectedResources: any[] = [];
  includesComplexResources: boolean = false;
  includesOptionalResources: boolean = false;

  systemChoosesAllResources: boolean = true;

  validselection: boolean[] = [];

  totalAdmissions: number = 0;

  maxadmissions: number = 0;
  minadmissions: number = 0;

  totalAdmissionInRange: boolean;
  PackageHasExtras: boolean;

  MinimumValidPayment:number = 0;
  MustIncludePass: boolean = true;

  httpResponse: any;
  BookingFee: cBookingfee;

  MembershipComplete: boolean = false;
  MembershipSummary: membershipsummary;
  
  packageGroups: any[];

  checked: any[] = [];
  popular: any;

  showDiscount: boolean = false;
  discountCode: string = "";

  BookingFeeAdddedOn: number = 0;
  DiscountTakenOff: number = 0;

  showPrintConfirmations: boolean = false;
  confHTML: string = "";

  TotalExtras: number = 0;
  minimumDiscount: number = 0;

  BookingPayments: Payment[] = [];
  totalPayments: number;

  showDeferReason: boolean = false;
  deferNotes: string = "";
  AvailabilityReq = {} as AvailabilityReq;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  stateOptionAllergy: any[];
  birthdayitems: birthdayanswers[] = [];

  mustanswerallergies: boolean[] = [];
  mustanswerbirthdays: boolean[] = [];
  mustanswernumber: boolean[] = [];
  mustanswerfreetext: boolean[] = [];
  mustanswermultichoicesingleanswer: boolean[] = [];
  mustanswermultichoicemultianswer: boolean[] = [];
  mustanswerdate: boolean[] = [];

  questionAnswers: questionanswers[] = [];
  questionAnswer: questionanswers;

  bookingFreeTextAnswer: string = "";
  bookingallergyanswer: string = "";
  bookingnumberanswer: number = 0;
  bookingdateanswer: Date = null;
  bookingmultichoicesingleanswer: bookingquestionitem = null;
  bookingmultichoicemultianswer: bookingquestionitem[] = [];
  showVoucher: boolean = false;
  voucherCode: string = "";
  voucherpin: string = "";

  timetobetried: string = "";

  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  allergyOptions: any[] = [{ name: 'Yes', value: true }, { name: 'No', value: false}];

  CurrentDate = new Date();//new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0,0,0,0);

  VoucherComplete: boolean = false;

  SummaryItinerary: boolean = false;

  allQuestionsValid: boolean = true;
  linkedAdmissionMessageShown: boolean = false;
  showWarning: boolean = false;
  WarningMessage: string = "";
  totalDiscount: number = 0;

  paymentButtonLocked: boolean = false;

  terminalHubConnection: HubConnection | null = null;
  awaitingTerminalPayment: boolean = false;
  showPaymentFailedDialog: boolean = false;
  paymentFailedMessage: string = '';
  showTerminalBusyDialog: boolean = false;
  private pendingPaymentId: string = '';
  private pendingPaymentName: string = '';
  private pendingTerminalPayload: any = null;
  private pendingTerminalRetry: (() => void) | null = null;
  private terminalPaymentResolved: boolean = false;
  private terminalPollingIntervalId: ReturnType<typeof setInterval> | null = null;

  stateOptionOpenDiscount: any[];
  stateGenderOptions: any[];

  openDiscount: boolean = false;

  chosenDiscountAmount: number = 0;

  showVCWarning: boolean = false;
  VCWarningMessage: string = "";

  venueClosings: any[] = [];

  caldays: any[] = [];
  calmonths: any[] = [];
  calyears: any[] = [];

  DOBDay: any[] = [];
  DOBMonth: any[] = [];
  DOBYear: any[] = [];

  DOBIsValid: boolean = true;
  dobage: any[] = [];

  ShowAge: boolean = false;
  ShowDOB: boolean = false;
  ShowGender: boolean = false;
  ShowInterests: boolean = false;

  oldDepositValue: number = 0;

  UseIntervalAvailability: boolean = false;

  NewAllowedMin: number = 0;

  ListMemberships: any[];

  ViewMemberships: boolean = true;
  ViewAdmissions: boolean = false;
  ViewDetails: boolean = false;
  ViewCustomer: boolean = false;
  ViewPayment: boolean = false;

  admissionsMaxReached: boolean = false;
  admissionsMaxReachedMessage: string = '';

  MembershipAdmissions: any[] = [];

  MemberAdmissions: any[] = [];
  DetailedMembershipAdmissions: any[] = [];

  thisMembershipSale: membershipsale;
  
  MembershipSaleResponse: any;

  validdob: boolean[]  = [];
  validdobinpast: boolean[]  = [];
  validname: boolean[]  = [];

  //A date of birth has to be yesterday or earlier, so this caps the calendar picker.
  maxDOB: Date = this.yesterday();

  membershipSummary: membershipsummary = {} as membershipsummary;

  ShowTitle: boolean = true;

  Total: number = 0;

  //What the sale was worth before the discount and any booking fee. The line on the payment
  //panel shows both of those as adjustments on the way to the total, so this takes them back
  //off it - a membership sale carries no value of its own to read instead.
  get saleValueBeforeAdjustments(): number {
    let discounts = this.thisMembershipSale?.totaldiscounts ?? 0;
    let fees = this.thisMembershipSale?.totalbookingfees ?? 0;

    return Math.round(((this.Total ?? 0) + discounts - fees) * 100) / 100;
  }

  get saleHasAdjustments(): boolean {
    return (this.thisMembershipSale?.totaldiscounts > 0) || (this.thisMembershipSale?.totalbookingfees > 0);
  }

  InScheduledSession:boolean = false;

  MembershipOrScheduledSession: string = "Membership";
  chosenMembership: any;
  scheduledSessionByMembershipTypeId: Map<string, any> = new Map();
  chosenScheduledSessionRecord: any = null;
  chosenScheduledSessionDates: Date[] = [];

  //#endregion

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private messageService: MessageService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private busyService: BusyService, private globalService: GlobalService, private auth: AuthService, private ngZone: NgZone) {
      this.stateOptions = [{ label: 'Use full personal details', value: "FULL" }, { label: 'Use limited personal details', value: "LIMITED"}, { label: 'Walk In', value: "WALKIN" }]; 
      this.stateOptionsMin = [{ label: 'Use full personal details', value: "FULL" }, { label: 'Use limited personal details', value: "LIMITED"}];    
      this.stateOptionAllergy = [{ label: 'Yes', value: true }, { label: 'No', value: false}];  
      this.stateOptionOpenDiscount = [{ label: 'Enter Discount Value', value: true }, { label: 'Enter Discount Code', value: false}]; 
      this.stateGenderOptions =  [{ label: 'Rather not say', value: 'NOT STATED' }, { label: 'Male', value: 'MALE'}, {label: 'Female', value: 'FEMALE'}]; 
      
      this.ShowTitle = true;

      this.dobage = [
        {name:'0 to 3 months', value:'0 to 3 months'},
        {name:'4 to 6 months', value:'4 to 6 months'},
        {name:'6 to 12 months', value:'6 to 12 months'},
        {name:'1', value:'1'},
        {name:'2', value:'2'},
        {name:'3', value:'3'},
        {name:'4', value:'4'},
        {name:'5', value:'5'},
        {name:'6', value:'6'},
        {name:'7', value:'7'},
        {name:'8', value:'8'},
        {name:'9', value:'9'},
        {name:'10', value:'10'},
        {name:'11', value:'11'},
        {name:'12', value:'12'},
        {name:'13', value:'13'},
        {name:'14', value:'14'},
        {name:'15', value:'15'},
        {name:'16', value:'16'},
        {name:'17', value:'17'},
        {name:'18', value:'18'},
        {name:'Over 18', value:'Over 18'}
      ];

      this.caldays =  [
        {name: '01', value:'01'},
        {name: '02', value:'02'},
        {name: '03', value:'03'},
        {name: '04', value:'04'},
        {name: '05', value:'05'},
        {name: '06', value:'06'},
        {name: '07', value:'07'},
        {name: '08', value:'08'},
        {name: '09', value:'09'},
        {name: '10', value:'10'},
        {name: '11', value:'11'},
        {name: '12', value:'12'},
        {name: '13', value:'13'},
        {name: '14', value:'14'},
        {name: '15', value:'15'},
        {name: '16', value:'16'},
        {name: '17', value:'17'},
        {name: '18', value:'18'},
        {name: '19', value:'19'},
        {name: '20', value:'20'},
        {name: '21', value:'21'},
        {name: '22', value:'22'},
        {name: '23', value:'23'},
        {name: '24', value:'24'},
        {name: '25', value:'25'},
        {name: '26', value:'26'},
        {name: '27', value:'27'},
        {name: '28', value:'28'},
        {name: '29', value:'29'},
        {name: '30', value:'30'},
        {name: '31', value:'31'}
      ];
          
      this.calmonths = [
        {name: '01', value:'01'},
        {name: '02', value:'02'},
        {name: '03', value:'03'},
        {name: '04', value:'04'},
        {name: '05', value:'05'},
        {name: '06', value:'06'},
        {name: '07', value:'07'},
        {name: '08', value:'08'},
        {name: '09', value:'09'},
        {name: '10', value:'10'},
        {name: '11', value:'11'},
        {name: '12', value:'12'}
      ];
      
      for(let i = 2050; i > 1920; i--)
        {
          let thisYear = new Date().getFullYear();
          if(i <= thisYear)
          {
            this.calyears.push({name: i.toString(), value: i.toString()});
          }
        }

        this.getMemberships();

        this.thisMembershipSale = {
          id: null,
          saleid: null,
          saleidhr: null,
          membershiptypeid: "",
          memberships: [],
          creationdate: new Date(),
          startdate: new Date(),
          lengthinmonths: 12,
          enddate: new Date,
          customer: null,
          payments: [],
          awaitingpayment: false,
          deferredpayment: false,
          disabled: false,
          venueid: this.VenueID,
          outstanding: 0,
          totaldiscounts: 0,
          totalvenuedeposit: 0,
          totalpublicdeposit: 0,
          totalpayments: 0,
          bookingfee: 0,
          discounts: null,  
          total: 0,
          membershipid: null,
          salesprice: 0

        }
  }

  //Each member carries a back-pointer to the sale it belongs to, so anything that reads a
  //member on its own - the session register, for one - can get back to the sale it came from.
  //Stamped again immediately before each save, not just when the member is built: a new sale
  //has no membershipid until the API has assigned one, so the value present at build time is
  //null on the first save and only becomes real once the sale has come back from the server.
  stampMembershipIdOnMembers()
  {
    if(this.thisMembershipSale == null || this.thisMembershipSale.memberships == null)
      return;

    this.thisMembershipSale.memberships.forEach(adm => {
      adm.membershipid = this.thisMembershipSale.membershipid;
    });
  }

  savemembershipsale(disabled: boolean = false){

    this.thisMembershipSale.disabled = disabled;
    this.thisMembershipSale.inprogress = true;
    this.thisMembershipSale.venueid = this.VenueID;

    this.thisMembershipSale.memberships.forEach(adm => {
      adm.membershiptypeid = this.thisMembershipSale.membershiptypeid;
      adm.questionnaire?.bookingquestions.forEach(q => {
        if (q.answers.allergyanswer.allergypresent == null) {
          q.answers.allergyanswer.allergypresent = false;
        }

        if(q.answers.dateanswer == null)
        {
          q.answers.dateanswer = new Date(1,1,1900);
        }
      });
    });

    this.busyService.busy();

    this.stampMembershipIdOnMembers();

    this.http.post<any>(bmxurl + "/savemembership", this.thisMembershipSale).subscribe(response => {
      this.MembershipSaleResponse = response
      if(this.MembershipSaleResponse.succeeded)
      {
        this.thisMembershipSale = this.MembershipSaleResponse.data;

        this.Total = this.thisMembershipSale.total;
        this.validPaymentAmount = this.thisMembershipSale.total;

        if(this.thisMembershipSale.total <= 0)
        {
          this.completeMembershipAfterPayment(this.thisMembershipSale);
        }
        else
        {
          this.ViewPayment = true;
        }

         this.busyService.idle();
      }
      else
      {
        this.busyService.idle();
        this.messageService.add({severity:'error', summary:'Failure', detail: 'Error Saving Membership, error: ' + this.MembershipSaleResponse.messages[0]});
      }
    }, error => {
      this.busyService.idle();
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Memberships, error: ' + error.messages});
    })
  }

  doneAdmissions(){

    this.admissionsMaxReached = false;

    var index = 0;
    var admissionsIndex = 1;
    let participants = 0;
    var oldAdmissionId = "";

    //count participants in selected admissions
    this.SelectedAdmissions.forEach(adm => {
      if(adm.participant)
        participants += adm.numberofadmissions;
    });

    let participantReq = {
      venueid: this.VenueID,
      membershiptypeid: this.thisMembershipSale.membershiptypeid, 
      noofparticipants: participants
    }

    //************************************************************

      let CanGetMembershipInfo: boolean = true;
      let PartReqResponse: any;

      this.busyService.busy();

      this.http.post(bmxurl + "membershipavailability", participantReq).subscribe(response => {

        this.busyService.idle();

        PartReqResponse = (response as any);
        if((response as any).succeeded){
          this.SelectedAdmissions.forEach(adm => {

            for(var i = 0; i < adm.numberofadmissions; i++)
            {
              let newQuestionnaire = adm.questionnaire != null ? JSON.parse(JSON.stringify(adm.questionnaire)) : null;
              if(newQuestionnaire != null && newQuestionnaire != null)
              {
                newQuestionnaire.bookingquestions.forEach((question: any) => {
                  question.answers = JSON.parse(JSON.stringify({
                    bookingid: "",
                    bookingquestionnaireid:  null,
                    bookingquestionid: question.bookingquestionid,
                    allergyanswer: {
                      id: null,
                      allergypresent: null,
                      allergytext: ""
                    },
                    freetextanswer: "",
                    numberanswer: null,
                    ageanswer: null,
                    dateanswer:  null,
                    multichoicesingleanswer: {
                      id: null,
                      listitemtext: ""
                    },
                    multichoicemultianswer: [],
                    
                    mustanswerallergies: true,
                    mustanswerbirthdays: true,
                    mustanswernumber: true, 
                    mustanswerfreetext: true,
                    mustanswermultichoicesingleanswer: true,
                    mustanswermultichoicemultianswer: true,
                    mustanswerdate: true,
                    mustanswerage: true
                  }));
                });
              }

              index++;
        
              if(oldAdmissionId == adm.admissionid)
              {
                admissionsIndex++;
              }
              else
              {
                admissionsIndex = 1;
              }

              var newAdm: memberadmission = {
                id: uuidv4(),
                index: index,
                name: adm.name,
                membershipadmissionid: adm.membershipadmissionid,
                min: adm.min,
                max: adm.max,
                price: adm.price,
                detailsrequired: adm.detailsrequired,
                admissionid: adm.admissionid,
                membername: "",
                //1/1/1900 is the sentinel the backend uses to detect that no date of birth
                //was captured. Members that don't require details never get a field to fill
                //in, so this is the value they keep.
                memberdob: new Date(1900, 0, 1),
                participant: adm.participant,
                membershiptypeid: this.thisMembershipSale.membershiptypeid,
                questionnaire:  newQuestionnaire,
                inprogress: true,
                admissionsindex: admissionsIndex,
                disabled: false,
                membershipid: this.thisMembershipSale.membershipid
              }

              oldAdmissionId = adm.admissionid;

              if(adm.detailsrequired)
              {
                //Left blank so the user has to choose a date rather than silently accepting
                //a default as the member's date of birth. Validation won't let this stay
                //null, so only members that don't require details reach the backend with
                //the 1/1/1900 sentinel above.
                newAdm.memberdob = null;
              }

              this.DetailedMembershipAdmissions.push(newAdm);
            }
          }
          );

          this.DetailedMembershipAdmissions.forEach(adm => {
            this.validname.push(false);
            this.validdob.push(false);
            this.validdobinpast.push(false);
          });

          this.ViewAdmissions = false;
          this.ViewDetails = true;
        }
        else
        {
          this.messageService.add({severity:'warn', summary:'Warning', detail: PartReqResponse.messages[0]});

          this.admissionsMaxReached = true;
          this.admissionsMaxReachedMessage = PartReqResponse.messages[0];
        }
      }, error => {
        this.busyService.idle();
        this.messageService.add({severity:'error', summary:'Failure', detail: 'Error checking availability, please try again.'});
      });

    //*************************************************************


    // this.SelectedAdmissions.forEach(adm => {
    //   for(var i = 0; i < adm.numberofadmissions; i++)
    //   {
    //     index++;
        
    //     if(oldAdmissionId == adm.admissionid)
    //     {
    //       admissionsIndex++;
    //     }
    //     else
    //     {
    //       admissionsIndex = 1;
    //     }
            
      // var newAdm: memberadmission = {
      //       id: uuidv4(),
      //       index: index,
      //       name: adm.name,
      //       membershipadmissionid: adm.membershipadmissionid,
      //       min: adm.min,
      //       max: adm.max,
      //       price: adm.price,
      //       detailsrequired: adm.detailsrequired,
      //       admissionid: adm.admissionid,
      //       membername: "",
      //       memberdob: new Date(),
      //       participant: adm.participant,
      //       membershiptypeid: this.thisMembershipSale.membershiptypeid,
      //       questionnaire:  newQuestionnaire,
      //       inprogress: true,
      //       admissionsindex: admissionsIndex
      //     }

        // oldAdmissionId = adm.admissionid;

        // if(adm.detailsrequired)
        // {
        //   newAdm.memberdob = new Date();
        // }

        // this.DetailedMembershipAdmissions.push(newAdm);
      //}
    //}
    //);

    this.DetailedMembershipAdmissions.forEach(adm => {
      this.validname.push(false);
      this.validdob.push(false);
      this.validdobinpast.push(false);
    });

    this.ViewAdmissions = false;
    this.ViewDetails = true;
  }

  validdatedetails(){
    let allvalid = true;

    this.DetailedMembershipAdmissions.forEach(adm => {
      if(adm.membername == null || adm.membername == "")
      {
        this.validname[adm.index - 1] = true;
        allvalid = false;
      }
      else
      {
        this.validname[adm.index - 1] = false;
      }

      if(adm.detailsrequired)
      {
        if(adm.memberdob == null || adm.memberdob == "" || this.isValidDate(adm.memberdob) == false)
        {
          this.validdob[adm.index - 1] = true;
          this.validdobinpast[adm.index - 1] = false;
          allvalid = false;
        }
        else if(!this.isBeforeToday(adm.memberdob))
        {
          //Typing straight into the field bypasses the calendar's maxDate, so today and
          //future dates have to be rejected here as well.
          this.validdob[adm.index - 1] = false;
          this.validdobinpast[adm.index - 1] = true;
          allvalid = false;
        }
        else
        {
          this.validdob[adm.index - 1] = false;
          this.validdobinpast[adm.index - 1] = false;
        }
      }

      if(adm.questionnaire != null && adm.questionnaire.bookingquestions != null)
      {
        adm.questionnaire.bookingquestions.forEach((question: any) => {
          if(question.questiontype == "ALLERGY")
          {
            if(question.answers.allergyanswer.allergypresent != null && question.answers.allergyanswer.allergypresent == true)
            {
              if(question.answers.allergyanswer.allergytext == "" && question.mandatory)
              {
                allvalid = false;
                question.answers.mustanswerallergies = false;
              }
              else
              {
                question.answers.mustanswerallergies = true;
              }
            }
            else
            {
              question.answers.mustanswerallergies = true;
            }
          }
          else if(question.questiontype == "NUMBER")
          {
            if(question.answers.numberanswer == null && question.mandatory)
            {
              allvalid   = false;
              question.answers.mustanswernumber = false
            }
            else
            {
              question.answers.mustanswernumber = true
            }
          }
          else if(question.questiontype == "AGE")
          {
            if(question.answers.ageanswer == null && question.mandatory)
            {
              allvalid   = false;
              question.answers.mustanswerage = false
            }
            else
            {
              question.answers.mustanswerage = true
            }
          }
          else if(question.questiontype == "FREETEXT")
          {
            if((question.answers.freetextanswer == null || question.answers.freetextanswer == "") && question.mandatory)
            {
              allvalid = false;
              question.answers.mustanswerfreetext = false;
            }
            else
            {
              question.answers.mustanswerfreetext = true;
            }
          }
          else if(question.questiontype == "DATE")
          {
            if(question.answers.dateanswer == null && question.mandatory)
            {
              allvalid = false;
              question.answers.mustanswerdate = false;
            }
            else
            {
              question.answers.mustanswerdate = true;
            }
          }
          else if(question.questiontype == "MULTICHOICESINGLE")
          {
            if(question.answers.multichoicesingleanswer.id == null && question.mandatory)
            {
              allvalid = false;
              question.answers.mustanswermultichoicesingleanswer = false;
            }
            else
            {
              question.answers.mustanswermultichoicesingleanswer = true;
            }

          }
          else if(question.questiontype == "MULTICHOICEMULTIPLE")
          {
            if(question.answers.multichoicemultianswer.length == 0 && question.mandatory)
            {
              allvalid = false;
              question.answers.mustanswermultichoicemultianswer = false;
            }
            else
            {
              question.answers.mustanswermultichoicemultianswer = true;
            }

          }

        });
      }
    });

    if(allvalid)
    {
      return true;
    }
    else
    {
      return false;
    }
  }

  doneDetails(){

    if(this.validdatedetails()){
      this.ViewDetails = false;
      this.ViewCustomer = true;

      this.thisMembershipSale.memberships = this.DetailedMembershipAdmissions;
    }
    else
    {

    }
  }

  getMemberships(){
      this.http.get(bmxurl + "membershiptypelist/" + this.VenueID + "/false").subscribe(response => {
        this.httpResponse = response
        if(this.httpResponse.succeeded)
        {
          this.ListMemberships = (response as membership_returndata).data;

          if( this.InScheduledSession == true)
          {
            this.ListMemberships = (response as membership_returndata).data.filter(m => m.membershiptype == "SCHEDULEDSESSION");
          }
          else
          {
            this.ListMemberships = (response as membership_returndata).data.filter(m => m.membershiptype != "SCHEDULEDSESSION");;
          }

          this.ListMemberships = this.ListMemberships.filter(m => {
            if(m.enddate != null && m.enddate != "" && this.isValidDate(m.enddate))
            {
              let endDate = new Date(m.enddate);
              return endDate >= new Date();
            }
            else
            {
              return true;
            }
          });

          if ((response as membership_returndata).messages.length > 0)
          {
            (response as membership_returndata).messages.forEach(error => {
              this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
            });
          }

          if(this.InScheduledSession == true)
          {
            // Scheduled sessions carry their own displayorder on the scheduledsession record
            // (kept in sync via the admin reorder screen's ScheduledSessionReorder call) -
            // the shared membershiptype table's displayorder is stale for this category.
            this.http.get(bmxurl + "scheduledsessionList/" + this.VenueID + "/false").subscribe((sessionResponse: any) => {
              if(sessionResponse.succeeded)
              {
                const displayOrderByMembershipTypeId = new Map<string, number>();
                this.scheduledSessionByMembershipTypeId.clear();
                sessionResponse.data.forEach(session => {
                  displayOrderByMembershipTypeId.set(session.membershiptypeid, session.displayorder ?? 0);
                  this.scheduledSessionByMembershipTypeId.set(session.membershiptypeid, session);
                });

                this.ListMemberships.sort((a, b) =>
                  (displayOrderByMembershipTypeId.get(a.membershiptypeid) ?? 0) -
                  (displayOrderByMembershipTypeId.get(b.membershiptypeid) ?? 0));
              }
              else
              {
                this.ListMemberships.sort((a, b) => (a.displayorder ?? a.displayOrder ?? 0) - (b.displayorder ?? b.displayOrder ?? 0));
              }
            }, error => {
              this.ListMemberships.sort((a, b) => (a.displayorder ?? a.displayOrder ?? 0) - (b.displayorder ?? b.displayOrder ?? 0));
            });
          }
          else
          {
            this.ListMemberships.sort((a, b) => (a.displayorder ?? a.displayOrder ?? 0) - (b.displayorder ?? b.displayOrder ?? 0));
          }
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error getting Memberships, error: ' + this.httpResponse.messages[0]});
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Memberships, error: ' + error.messages});
      });
  }

  sendPaymentLink(){

    // this.thisMembershipSale.payments = null;
    // this.thisMembershipSale.awaitingpayment = true;

    // this.http.post<any>(bmxurl + "/Payment", this.thisMembershipSale).subscribe(response => {
    //  this.MembershipResponse = response
    //  this.BookingDateAndTime = new Date(this.MembershipResponse.data.startTime).getUTCDate().toString().padStart(2, '0') + "/" + new Date(this.BookingResponse.data.startTime).getUTCMonth().toString().padStart(2, '0') + "/" + new Date(this.BookingResponse.data.startTime).getUTCFullYear() + " " + new Date(this.BookingResponse.data.startTime).getUTCHours().toString().padStart(2, '0') + ":" + new Date(this.BookingResponse.data.startTime).getUTCMinutes().toString().padStart(2, '0');

    //  this.BookingPackage = this.MembershipResponse.data.packageName;
    
    //  this.http.get<any>(bmxurl + "sendpaymentlink/" + this.VenueID + "/" + this.thisMembershipSale.saleid).subscribe(response => {
    //   this.httpResponse = response;

    //   if(!this.httpResponse.succeeded)
    //   {
    //     this.messageService.add({severity:'error', summary:'Failure', detail: this.httpResponse.messages[0]});
    //   }
    //   else
    //   {
    //     if(this.MembershipResponse.data.payments != null)
    //     {
    //       if(this.MembershipResponse.data.payments.length > 0)
    //       {
    //         this.messageService.add({severity:'success', summary:'Success', detail: 'Payment link sent'});
    //       }
    //       else
    //       {
    //         this.messageService.add({severity:'success', summary:'Success', detail: 'Payment link sent, the customer will have 4 hours to respond to this link otherwise the booking will be cancelled. Cancelled bookings cannot be paid.'});
    //       }
    //     }
    //     else
    //     {
    //       this.messageService.add({severity:'success', summary:'Success', detail: 'Payment link sent, the customer will have 4 hours to respond to this link otherwise the booking will be cancelled. Cancelled bookings cannot be paid.'});
    //     }
    //     this.DoSummary(this.MembershipResponse.data);
    //   }

    // }, error => {
    //   this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send the Email'});
    // })

    // }, error => {
    //   this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to defer payment'});
    // })

    let templateId = this.chosenMembership.emailtemplate.emailtemplateid;

    // this.http.get(bmxurl + "sendmembershiplink/" + this.VenueID + "/" + this.thisMembershipSale.membershipid + "/" + templateId).subscribe(response => {
    //   this.httpResponse =  (response as users_returndata)
    //   if(this.httpResponse.succeeded)
    //   {
    //     alert("Membership link sent");
    //   }
    // }, error => {
    //   this.messageService.add({severity:'error', summary:'Not Found', detail: 'Error getting user details, error: ' + error.messages});
    // });
  }

  isValidDate(dateString: string): boolean {
     //check if date is valid
      let date = new Date(dateString);
      return date instanceof Date && !isNaN(date.getTime());
  }

  //As above, for the name - clears the message as soon as something is typed rather than
  //leaving it next to a field that now has a value in it.
  nameChanged(adm: any) {
    if(adm.membername != null && adm.membername != "")
    {
      this.validname[adm.index - 1] = false;
    }
  }

  //Clears the validation message as soon as a date is picked, so a message left over from
  //a previous Continue attempt doesn't sit next to a field that is now filled in.
  dobChanged(adm: any) {
    if(!adm.detailsrequired)
    {
      return;
    }

    let index = adm.index - 1;

    if(adm.memberdob == null || adm.memberdob == "" || this.isValidDate(adm.memberdob) == false)
    {
      //Cleared or part-way through typing - say nothing, Continue still blocks on it.
      this.validdob[index] = false;
      this.validdobinpast[index] = false;
      return;
    }

    this.validdob[index] = false;
    this.validdobinpast[index] = !this.isBeforeToday(adm.memberdob);
  }

  //Midnight yesterday - the latest date that can be a date of birth.
  yesterday(): Date {
    let date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() - 1);
    return date;
  }

  //Compared at midnight so any time component on the picked date is ignored, otherwise
  //a date of birth of "today at 00:00" would slip past a straight < now comparison.
  isBeforeToday(dateString: any): boolean {
    let date = new Date(dateString);
    date.setHours(0, 0, 0, 0);

    let today = new Date();
    today.setHours(0, 0, 0, 0);

    return date.getTime() < today.getTime();
  }

  computeScheduledSessionDates(startdate: string, numberofweeks: number): Date[] {
    const dates: Date[] = [];
    const start = new Date(startdate);
    const weeks = numberofweeks ?? 1;

    for (let i = 0; i < weeks; i++) {
      const sessionDate = new Date(start);
      sessionDate.setDate(sessionDate.getDate() + (i * 7));
      dates.push(sessionDate);
    }

    return dates;
  }

  addScheduledSessionToCalendar(): void {
    if (!this.chosenScheduledSessionDates || this.chosenScheduledSessionDates.length === 0) {
      return;
    }

    const durationMinutes = this.chosenScheduledSessionRecord?.duration ?? 60;
    const title = this.chosenMembership?.name ?? 'Scheduled Session';
    const plainDescription = (this.chosenMembership?.description ?? '').replace(/<[^>]*>/g, '').trim();

    const pad = (n: number) => n.toString().padStart(2, '0');
    const formatICSDate = (d: Date): string =>
      d.getFullYear().toString() + pad(d.getMonth() + 1) + pad(d.getDate()) + 'T' + pad(d.getHours()) + pad(d.getMinutes()) + pad(d.getSeconds());
    const escapeICS = (text: string): string => text.replace(/([,;])/g, '\\$1').replace(/\r?\n/g, '\\n');

    const now = formatICSDate(new Date());
    const icsLines: string[] = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Windermere//Scheduled Sessions//EN',
      'CALSCALE:GREGORIAN'
    ];

    this.chosenScheduledSessionDates.forEach((sessionDate, index) => {
      const endDate = new Date(sessionDate.getTime() + durationMinutes * 60000);

      icsLines.push(
        'BEGIN:VEVENT',
        'UID:' + this.genRandomNum() + '-' + index + '@windermere',
        'DTSTAMP:' + now,
        'DTSTART:' + formatICSDate(sessionDate),
        'DTEND:' + formatICSDate(endDate),
        'SUMMARY:' + escapeICS(title),
        'DESCRIPTION:' + escapeICS(plainDescription),
        'END:VEVENT'
      );
    });

    icsLines.push('END:VCALENDAR');

    const blob = new Blob([icsLines.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = title.replace(/[^a-z0-9]/gi, '_') + '_dates.ics';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  }

  IsToday()
  {
    var today = new Date();
    var selected = new Date(this.SelectedDate);
    return today.getDate() == selected.getDate() && today.getMonth() == selected.getMonth() && today.getFullYear() == selected.getFullYear();
  }

  doReferralNote(){
    this.showDeferReason = false;

    this.thisMembershipSale.payments = null;
    this.thisMembershipSale.deferredpayment = true;
    this.thisMembershipSale.notes = this.deferNotes;
    this.thisMembershipSale.venueid = this.VenueID;

    this.stampMembershipIdOnMembers();

    this.http.post<any>(bmxurl + "/defermembershippayment", this.thisMembershipSale).subscribe(response => {
      this.MembershipResponse = response.data

      if(response.succeeded)
      {
        this.MembershipComplete = true;
        this.ViewPayment = false;

        this.ShowTitle = false;

        //create membership summary
        this.membershipSummary.PIN = this.MembershipResponse.membershippin;
        this.membershipSummary.membershipidhr = this.MembershipResponse.salesid;
        this.membershipSummary.startTime = this.MembershipResponse.startdate;
        this.membershipSummary.endTime = this.MembershipResponse.enddate;
        this.membershipSummary.scheduleddates = this.MembershipResponse.scheduleddates;

        let memTypeID = this.MembershipResponse.membershiptypeid;

        this.ListMemberships.forEach(m => {
          if(m.membershiptypeid == memTypeID)
          {
            this.membershipSummary.membershipType = m.name;
          }
          });

            this.membershipSummary.admissions = "";
            this.MembershipResponse.memberships.forEach(adm => {
              if(adm.detailsrequired)
              {
                this.membershipSummary.admissions += adm.membername + " (" + new Date(adm.memberdob).toLocaleDateString().padStart(10, '0') + "), ";
              }
              else
              {
                this.membershipSummary.admissions += adm.membername + ", ";
              }
            });

            this.membershipSummary.admissions = this.membershipSummary.admissions.substring(0, this.membershipSummary.admissions.length - 2);

            this.membershipSummary.customerName = this.MembershipResponse.customer.firstName + " " + this.MembershipResponse.customer.lastName;
            this.membershipSummary.customerAddress = this.MembershipResponse.customer.address1 + " " + this.MembershipResponse.customer.address2 + "\n" + this.MembershipResponse.customer.townCity + "\n" + this.MembershipResponse.customer.postCode;

            this.membershipSummary.customerMobile = this.MembershipResponse.customer.mobile;
            this.membershipSummary.customerEmail = this.MembershipResponse.customer.email;

            if (this.MembershipResponse.payments != null && this.MembershipResponse.payments.length > 0)
            {
              this.membershipSummary.paid = this.MembershipResponse.payments[0].amount;
            }
            else
            {
              this.membershipSummary.paid = 0;
            }

            //Reason the payment was deferred, shown at the foot of the summary. Taken from
            //the entered text rather than the response so it survives the API not echoing
            //the notes back.
            this.membershipSummary.deferrednote = this.deferNotes;
          }
          else
          {
            this.messageService.add({severity:'error', summary:'Failure', detail: 'Failed to Defer Payment, error: ' + (response as any).messages?.[0]});
          }
      }, error => {
        this.messageService.add({severity:'error', summary:'Failure', detail: 'Failed to Defer Payment, error: ' + (error.messages ?? error.message)});
      })




   }

  genRandomNum()
  {
    return Math.floor((Math.random()*10000)+1).toString();
  }

  doneDiscount(){
    let dv: cMembershipDiscountvalidate = {
      membership: this.thisMembershipSale,
      discountcode: this.discountCode.trim()
    }

    this.http.post<booking_returndata>(bmxurl + "/DiscountValidateMembership", dv).subscribe(response => {
      this.httpResponse = response
      if (this.httpResponse.succeeded == true) {
        this.messageService.add({ severity: 'success', summary: 'Discount Added', detail: 'Your discount has been added' });

        this.showDiscount = false;
        this.discountCode = "";

        this.thisMembershipSale = (response as booking_returndata).data;

        this.Total = this.thisMembershipSale.total;

        this.busyService.idle();
      }
      else
      {
        this.messageService.add({ severity: 'error', summary: 'Not Added', detail:(this.httpResponse.messages[0])});
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error.messages[0] });
    })
  }

  doneOpenDiscount(){
        let dv: cMembershipOpenDiscountvalidate = {
          membership: this.thisMembershipSale,
          value : this.chosenDiscountAmount
        }
    
        this.http.post<any>(bmxurl + "/OpenDiscountMembership", dv).subscribe(response => {
          this.httpResponse = response
          if (this.httpResponse.succeeded == true) {
            this.messageService.add({ severity: 'success', summary: 'Discount Added', detail: 'Your discount has been added' });
    
            this.showDiscount = false;
            this.discountCode = "";
    
            this.thisMembershipSale = (response as any).data;

            this.Total = this.thisMembershipSale.total;
            this.validPaymentAmount = this.thisMembershipSale.total;
          }
          else
          {
            this.messageService.add({ severity: 'error', summary: 'Not Added', detail:(this.httpResponse.messages[0])});
          }
        }, error => {
          this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error.messages[0] });
        })
  }

  displayDiscount(){
    this.showDiscount = !this.showDiscount;
  }

  displayVoucher(){
    this.showVoucher = !this.showVoucher;
  }
  
  addselectedCustomer(passCustomer){
    this.searchCriteria = "";

    this.CustomerHeader = "Customer: " +  passCustomer.firstName + "  " + passCustomer.lastName;

    let newCustomer: Customer = {
      id: passCustomer.id,
      customerid: passCustomer.customerid,
      firstName: passCustomer.firstName,
      lastName: passCustomer.lastName,
      fullName: passCustomer.firstName + " " + passCustomer.lastName,
      address1: passCustomer.address1,
      address2: passCustomer.address2,
      townCity: passCustomer.townCity,
      postCode: passCustomer.postCode,
      email: passCustomer.email,
      mobile: passCustomer.mobile,
      dob: this.dob,
      venueId: this.VenueID,
      disabled: false,
      bookingid: null
    }
    
    this.customersResult = null;
    this.searchCriteria = "";

    this.thisMembershipSale.customer = newCustomer;

    this.savemembershipsale(false);

    this.ViewCustomer = false;

    if(this.thisMembershipSale.total > 0)
    {
      this.ViewPayment = true;
    }

  }

  doneMembership(mmbrshp){

    this.chosenMembership = mmbrshp;
    this.totalPayments = 0;

    this.ViewMemberships = false;
    this.ViewAdmissions = true;

    if(this.InScheduledSession)
    {
      const session = this.scheduledSessionByMembershipTypeId.get(mmbrshp.membershiptypeid);
      this.chosenScheduledSessionRecord = session ?? null;
      this.chosenScheduledSessionDates = session ? this.computeScheduledSessionDates(session.startdate, session.numberofweeks) : [];
    }
    else
    {
      this.chosenScheduledSessionRecord = null;
      this.chosenScheduledSessionDates = [];
    }

    this.MembershipAdmissions = mmbrshp.membershipadmissions;

    this.MembershipAdmissions.forEach(adm => {
      var newAdm: membershipadmission = {
          id: adm.id,
          index: adm.index,
          name: adm.name,
          membershipadmissionid: adm.membershipadmissionid,
          min: adm.min,
          max: adm.max,
          price: adm.price,
          detailsrequired: adm.detailsrequired,
          admissionid: adm.admissionid,
          numberofadmissions: adm.min,
          participant: adm.participant,
          membershiptypeid: mmbrshp.membershiptypeid,
          questionnaire: mmbrshp.questionnaire,
          inprogress: true,
          admissionsindex: adm.admissionsindex
      }

      this.SelectedAdmissions.push(newAdm);

      this.totalPayments += this.thisMembershipSale.total;

      this.thisMembershipSale.membershiptypeid = mmbrshp.membershiptypeid;
    });

  }

  addCustomer(){
    //Check Search field for postcode

    if(this.valid_postcode(this.searchCriteria))
    {
      this.postCode = this.searchCriteria
    }
    else if(this.valid_mobile(this.searchCriteria))
    {
      //Check Telephone number
      this.mobile = this.searchCriteria
    }
    else if(this.searchCriteria.includes("@"))
    {
      this.email = this.searchCriteria
    }
    else
    {
      this.lastName = this.searchCriteria
    }


    this.ShowCustomerDetails = true;
    //this.ProvideMinimalPersonalData = "FULL";
  }

  valid_postcode(postcode) {
    if(this.searchCriteria != null && this.searchCriteria != "")
    {
        postcode = postcode.replace(/\s/g, "");
        var regex = /^[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}$/i;
        return regex.test(postcode);
    }
    else
    {
      return true;
    }
  }

  valid_mobile(postcode) {
    if(this.searchCriteria != null && this.searchCriteria != "")
      {
        postcode = postcode.replace(/\s/g, "");
        var regex = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
        return regex.test(postcode);
      }
      else 
      {
        return true;
      }
  }

  ngOnInit(): void {

    this.router.events.forEach(item => {
        if(this.router.url == "/sellscheduledsession")
        {
          this.InScheduledSession = true;
          this.MembershipOrScheduledSession = "Scheduled Session";
        }
        else
        {
          this.InScheduledSession = false;
          this.MembershipOrScheduledSession = "Membership";
        }
      });

    this.globalService.setSmallScreenMenu(false);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");

    let userid = localStorage.getItem("SmartUserID");
    
    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        this.http.get(bmxurl + "paymenttypes").subscribe(response => {
          if((response as paymenttypes_returndata).succeeded)
          {
            this.PaymentTypes = (response as paymenttypes_returndata).data;

            this.PaymentTypes = this.PaymentTypes.filter(pt => pt.system == false);
          }
          else
          {
            this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Payment Types.'});
          }
        }, error => {
          this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Payment Types.'});
        })
        
        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });

  }

  DatifyString(date: string): Date
  {
    let returnDate = new Date();

    returnDate.setUTCFullYear(Number(date.substring(0, 4)));
    returnDate.setUTCMonth(Number(date.substring(5, 7)) - 1);
    returnDate.setUTCDate(Number(date.substring(8, 10)));
    returnDate.setUTCHours(0);
    returnDate.setUTCMinutes(0);
    returnDate.setUTCSeconds(0);

    return returnDate;
  }

  applyCustomer(passCustomer)
  {
    this.ShowCustomerDetails = true;
    this.firstName = passCustomer.firstName;
    this.lastName = passCustomer.lastName;
    this.address1 = passCustomer.address1;
    this.address2 = passCustomer.address2;
    this.town = passCustomer.townCity;
    this.postCode = passCustomer.postCode;
    this.email = passCustomer.email;
    this. mobile = passCustomer.mobile;

    this.customersResult = null;
    this.searchCriteria = "";

  }

  searchCustomer(){
    this.http.get(bmxurl + "customer/search/" + this.VenueID + "/" + this.searchCriteria).subscribe(response => {
      this.customersResult = (response as customer[])
    }, error => {
    })

  }

  toggleMore(inDiv)
  {
    let collapsedDiv = document.getElementById(inDiv + "collapse") as HTMLElement;
    let expandeddDiv = document.getElementById(inDiv + "expanded") as HTMLElement;
    let toggleButton = document.getElementById(inDiv + "toggleButton") as HTMLButtonElement;

    if(collapsedDiv.hidden == true)
    {
      collapsedDiv.hidden = false
      collapsedDiv.style.display = "false";
    }
    else
    {
      collapsedDiv.hidden = true
      collapsedDiv.style.display = "true";
    }

    if(expandeddDiv.hidden == true)
    {
      expandeddDiv.hidden = false
      expandeddDiv.style.display = "false";
    }
    else
    {
      expandeddDiv.hidden = true
      expandeddDiv.style.display = "true";
    }

    if(toggleButton.value == "Show More...")
    {
      toggleButton.value = "Show Less..."
      toggleButton.textContent = "Show Less..."
    }
    else
    {
      toggleButton.value = "Show More..."
      toggleButton.textContent = "Show More..."
    }
  }

  Checkfortoday()
  {
    var today = new Date();
    var selected = new Date(this.SelectedDate);
    return today.getDate() == selected.getDate() && today.getMonth() == selected.getMonth() && today.getFullYear() == selected.getFullYear();
  }

  removeDiscount()
  {
    this.busyService.busy();

    this.thisMembershipSale.discounts = null;

    this.stampMembershipIdOnMembers();

    this.http.put<booking_returndata>(bmxurl + "/savemembership", this.thisMembershipSale).subscribe(response => {
      this.httpResponse = (response as booking_returndata);     

      this.MembershipSaleResponse = this.httpResponse.data

        this.thisMembershipSale = this.MembershipSaleResponse;

        this.validPaymentAmount = this.MembershipSaleResponse.outstanding;
  
        this.paymentAmount = this.MembershipSaleResponse.total;
        let NumPeople: number = 0;

        this.paymentAmount = this.MembershipSaleResponse.total;

        this.Total = this.MembershipSaleResponse.total;

        const formatter = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: this.CurrencySymbol});
  
        this.startTimes = null;
        this.startTimesFiltered = null;
  
        this.messageService.add({ severity: 'success', summary: 'Discount Removed', detail: 'Your discount has been removed' });

        this.busyService.idle();

    }, error => {
      this.busyService.idle();
    })
  }

  doneCustomer()
  {
    this.CustomerAllValid = true;

    if(this.ProvideMinimalPersonalData == "WALKIN")
    {
      if (this.lastName == "") {
        this.CustomerAllValid = false;
        this.lastNameValid = false;
      }
      else {
        this.lastNameValid = true;
      }
    }
    else if(this.ProvideMinimalPersonalData)
    {
      if (this.firstName == "") {
        this.CustomerAllValid = false;
        this.firstNameValid = false;
      }
      else {
        this.firstNameValid = true;
      }

      if (this.lastName == "") {
        this.CustomerAllValid = false;
        this.lastNameValid = false;
      }
      else {
        this.lastNameValid = true;
      }

      if (this.email == "") {
        if(this.ProvideMinimalPersonalData == "FULL" || this.ProvideMinimalPersonalData == "LIMITED")
        {
          this.CustomerAllValid = false;
          this.EmailValid = false;
        }
        else
        {
          this.EmailValid = true;
        }
      }
      else {
        this.EmailValid = true;
      }

      if (this.mobile == "") {
        if(this.ProvideMinimalPersonalData == "FULL" || this.ProvideMinimalPersonalData == "LIMITED")
        {
          this.CustomerAllValid = false;
          this.MobileValid = false;
        }
        else
        {
          this.MobileValid = true;
        }
      }
      else {
        this.MobileValid = true;
      }
    }
    else
    {
      if (this.firstName == "") {
        this.CustomerAllValid = false;
        this.firstNameValid = false;
      }
      else {
        this.firstNameValid = true;
      }

      if (this.lastName == "") {
        this.CustomerAllValid = false;
        this.lastNameValid = false;
      }
      else {
        this.lastNameValid = true;
      }

      if (this.address1 == "") {
        this.CustomerAllValid = false;
        this.Address1Valid = false;
      }
      else {
        this.Address1Valid = true;
      }

      if (this.town == "") {
        this.CustomerAllValid = false;
        this.TownValid = false;
      }
      else {
        this.TownValid = true;
      }

      if (this.postCode == "") {
        this.CustomerAllValid = false;
        this.PostCodeValid = false;
      }
      else {
        this.PostCodeValid = true;
      }

      if (this.email == "") {
        this.CustomerAllValid = false;
        this.EmailValid = false;
      }
      else {
        this.EmailValid = true;
      }

      if (this.mobile == "") {
        this.CustomerAllValid = false;
        this.MobileValid = false;
      }
      else {
        this.MobileValid = true;
      }
    }


    //Check for valid email and mobile

    if (this.email != "") {
      if (!this.validateEmail(this.email)) {
        this.CustomerAllValid = false;
        this.EmailFormatValid = false;
      }
      else {
        this.EmailFormatValid = true;
      }
    }

    if(this.mobile != ""){
      if (!this.validateMobile(this.mobile)) {
        this.CustomerAllValid = false;
        this.MobileFormatValid = false;
      }
      else {
        this.MobileFormatValid = true;
      }
    }

    if(this.CustomerAllValid == true)
    {
      this.CustomerHeader = "Customer: " + this.firstName + "  " + this.lastName;

      let newCustomer: Customer = {
        id: null,
        customerid: null,
        firstName: this.firstName,
        lastName: this.lastName,
        fullName: this.firstName + " " + this.lastName,
        address1: this.address1,
        address2: this.address2,
        townCity: this.town,
        postCode: this.postCode,
        email: this.email,
        mobile: this.mobile,
        dob: this.dob,
        venueId: this.VenueID,
        disabled: true,
        bookingid: null
      }

      this.thisMembershipSale.customer = newCustomer;
      //this.busyService.busy();

      this.savemembershipsale(false);

      this.ViewCustomer = false;

      if(this.thisMembershipSale.total > 0)
      {
        this.ViewPayment = true;
      }
    
    }
  }

  validateEmail(email){ 
    var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/; 
    return re.test(email); 
  }

  validateMobile(mobile){ 
    var re = /^(\+44\s?|0)7\d{9}$/; 
    return re.test(mobile); 
  }

  deferPayment(){
    this.showDeferReason = true;
  }

  DoSummary(BookingSummary){
    this.MembershipComplete = true;
  }

  donePayment(paymentid: string, paymentname : string)
  {

    this.paymentButtonLocked = true;

    this.AllValid = true;
    let AmountDue:number =this.validPaymentAmount;

    if (this.totalPayments == null || (this.totalPayments < 0)) {
      this.AllValid = false;
      this.paymentValueValid = false;
    }
    else {
      this.paymentValueValid = true;
      this.AllValid = true;
    }

    if(this.AllValid)
    {
      const generalTerminalName = localStorage.getItem(`GeneralTerminalName_${this.VenueID}`) ?? '';
      const isCardPayment = paymentname.toLowerCase().includes('card');

      if (isCardPayment && generalTerminalName) {
        this.pendingPaymentId = paymentid;
        this.pendingPaymentName = paymentname;

        const terminalPayload = {
          venueid: this.VenueID,
          connectedAccountId: localStorage.getItem('RyftSubAccountID') ?? '',
          amount: Math.round(this.validPaymentAmount * 100),
          currency: this.CurrencySymbol.toLowerCase(),
          terminalId: generalTerminalName,
          method: 'MEMBERSHIP',
          identifier: this.thisMembershipSale.membershipid ?? ''
        };

        this.initiateMembershipTerminalPayment(terminalPayload);
        return;
      }

      let newPayment: Payment = {
        id: null,
        PaymentId: null,
        BookingId: null,
        bookingIdHR: null,
        method: paymentname,
        paymenttypeid: paymentid,
        amount: this.Total,
        paymentDate: new Date,
        disabled: false,
        venueid: this.VenueID,
        refunds: null,
        balance: this.Total,
        paymenttype: "membership",
        currency: this.CurrencySymbol,
        tillname: null
      }

      //this.thisMembershipSale.payments = [];
      this.thisMembershipSale.payments.push(newPayment);

      this.stampMembershipIdOnMembers();

      this.http.post<booking_returndata>(bmxurl + "/savemembership", this.thisMembershipSale).subscribe(response => {
        this.MembershipResponse = (response as any).data
        
        if(response.succeeded == true)
        {
          this.MembershipComplete = true;
          this.ViewPayment = false;

          this.ShowTitle = false;

          //create membership summary
          this.membershipSummary.PIN = this.MembershipResponse.membershippin;
          this.membershipSummary.membershipidhr = this.MembershipResponse.salesid;
          this.membershipSummary.startTime = this.MembershipResponse.startdate;
          this.membershipSummary.endTime = this.MembershipResponse.enddate;
          this.membershipSummary.scheduleddates = this.MembershipResponse.scheduleddates;

          let memTypeID = this.MembershipResponse.membershiptypeid;

          this.ListMemberships.forEach(m => {
            if(m.membershiptypeid == memTypeID)
            {
              this.membershipSummary.membershipType = m.name;
            }
         });

          this.membershipSummary.admissions = "";
          this.MembershipResponse.memberships.forEach(adm => {
            if(adm.detailsrequired)
            {
              this.membershipSummary.admissions += adm.membername + " (" + new Date(adm.memberdob).toLocaleDateString().padStart(10, '0') + "), ";
            }
            else
            {
              this.membershipSummary.admissions += adm.membername + ", ";
            }
          });

          this.membershipSummary.admissions = this.membershipSummary.admissions.substring(0, this.membershipSummary.admissions.length - 2);

          this.membershipSummary.customerName = this.MembershipResponse.customer.firstName + " " + this.MembershipResponse.customer.lastName;
          this.membershipSummary.customerAddress = this.MembershipResponse.customer.address1 + " " + this.MembershipResponse.customer.address2 + "\n" + this.MembershipResponse.customer.townCity + "\n" + this.MembershipResponse.customer.postCode;

          this.membershipSummary.customerMobile = this.MembershipResponse.customer.mobile;
          this.membershipSummary.customerEmail = this.MembershipResponse.customer.email;

          this.membershipSummary.paid = this.MembershipResponse.payments[0].amount;
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: this.httpResponse.messages});
          this.paymentButtonLocked = false;
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Error', detail: error.message});
        this.paymentButtonLocked = false;
      })
    }
  }  
  
  connectTerminalHubMembership(paymentIntentId: string): void {
    this.awaitingTerminalPayment = true;
    this.terminalPaymentResolved = false;

    this.terminalPollingIntervalId = setInterval(() => {
      this.ngZone.run(() => this.pollMembershipForPayment());
    }, 10000);

    this.auth.getAccessTokenSilently().subscribe({
      next: (token) => {
        const hub = new HubConnectionBuilder()
          .withUrl(environment.servicestarget + '/venue/' + this.VenueID, {
            accessTokenFactory: () => token
          })
          .build();

        this.terminalHubConnection = hub;

        hub.on(paymentIntentId, (message: string) => {
          this.ngZone.run(() => {
            if (this.terminalPaymentResolved) return;
            this.terminalPaymentResolved = true;
            this.stopTerminalPolling();
            hub.stop();
            this.terminalHubConnection = null;
            this.awaitingTerminalPayment = false;

            if (message === 'succeeded') {
              this.messageService.add({ severity: 'success', summary: 'Payment Succeeded', detail: 'Card payment completed successfully.' });

              let newPayment: Payment = {
                id: null,
                PaymentId: null,
                BookingId: null,
                bookingIdHR: null,
                method: this.pendingPaymentName,
                paymenttypeid: this.pendingPaymentId,
                amount: this.Total,
                paymentDate: new Date,
                disabled: false,
                venueid: this.VenueID,
                refunds: null,
                balance: this.Total,
                paymenttype: "membership",
                currency: this.CurrencySymbol,
                tillname: null
              };

              this.thisMembershipSale.payments.push(newPayment);

              this.stampMembershipIdOnMembers();

              this.http.post<booking_returndata>(bmxurl + "/savemembership", this.thisMembershipSale).subscribe(response => {
                this.MembershipResponse = (response as any).data;

                if (response.succeeded) {
                  this.completeMembershipAfterPayment(this.MembershipResponse);
                } else {
                  this.messageService.add({ severity: 'error', summary: 'Error', detail: this.httpResponse.messages });
                  this.paymentButtonLocked = false;
                }
              }, error => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message });
                this.paymentButtonLocked = false;
              });
            } else {
              this.paymentFailedMessage = message;
              this.showPaymentFailedDialog = true;
              this.paymentButtonLocked = false;
            }
          });
        });

        hub.start().catch(() => {
          this.terminalHubConnection = null;
        });
      },
      error: () => { /* polling continues */ }
    });
  }

  private pollMembershipForPayment(): void {
    if (this.terminalPaymentResolved) {
      this.stopTerminalPolling();
      return;
    }

    this.http.get<any>(bmxurl + 'membership/' + this.VenueID + '/' + this.thisMembershipSale.membershipid).subscribe(response => {
      if (this.terminalPaymentResolved) return;

      if (response.succeeded && response.data.payments?.length > 0) {
        this.terminalPaymentResolved = true;
        this.stopTerminalPolling();
        if (this.terminalHubConnection) {
          this.terminalHubConnection.stop();
          this.terminalHubConnection = null;
        }
        this.awaitingTerminalPayment = false;
        this.MembershipResponse = response.data;
        this.messageService.add({ severity: 'success', summary: 'Payment Received', detail: 'Payment confirmed via terminal.' });
        this.completeMembershipAfterPayment(this.MembershipResponse);
      }
    });
  }

  private completeMembershipAfterPayment(membershipData: any): void {
    this.MembershipComplete = true;
    this.ViewPayment = false;
    this.ShowTitle = false;

    this.membershipSummary.PIN = membershipData.membershippin;
    this.membershipSummary.membershipidhr = membershipData.salesid;
    this.membershipSummary.startTime = membershipData.startdate;
    this.membershipSummary.endTime = membershipData.enddate;
    this.membershipSummary.scheduleddates = membershipData.scheduleddates;

    const memTypeID = membershipData.membershiptypeid;
    this.ListMemberships.forEach(m => {
      if (m.membershiptypeid == memTypeID) {
        this.membershipSummary.membershipType = m.name;
      }
    });

    this.membershipSummary.admissions = "";
    membershipData.memberships.forEach(adm => {
      if (adm.detailsrequired) {
        this.membershipSummary.admissions += adm.membername + " (" + new Date(adm.memberdob).toLocaleDateString().padStart(10, '0') + "), ";
      } else {
        this.membershipSummary.admissions += adm.membername + ", ";
      }
    });
    this.membershipSummary.admissions = this.membershipSummary.admissions.substring(0, this.membershipSummary.admissions.length - 2);

    this.membershipSummary.customerName = membershipData.customer.firstName + " " + membershipData.customer.lastName;
    this.membershipSummary.customerAddress = membershipData.customer.address1 + " " + membershipData.customer.address2 + "\n" + membershipData.customer.townCity + "\n" + membershipData.customer.postCode;
    this.membershipSummary.customerMobile = membershipData.customer.mobile;
    this.membershipSummary.customerEmail = membershipData.customer.email;
    this.membershipSummary.paid = membershipData.payments?.[0]?.amount ?? 0;

    this.paymentButtonLocked = false;
  }

  private stopTerminalPolling(): void {
    if (this.terminalPollingIntervalId !== null) {
      clearInterval(this.terminalPollingIntervalId);
      this.terminalPollingIntervalId = null;
    }
  }

  private initiateMembershipTerminalPayment(terminalPayload: any): void {
    this.http.post<any>(bmxurl + 'StripeTerminalPaymentInit', terminalPayload).subscribe(response => {
      this.httpResponse = response;
      if (this.httpResponse.succeeded) {
        const paymentIntentId: string = this.httpResponse.data?.paymentIntentId ?? this.httpResponse.data?.id ?? '';
        this.connectTerminalHubMembership(paymentIntentId);
      } else {
        const detail = this.httpResponse.messages?.[0] ?? 'Unknown error';
        if (detail.toLowerCase().includes('payment_intent in progress')) {
          this.pendingTerminalPayload = terminalPayload;
          this.pendingTerminalRetry = () => this.initiateMembershipTerminalPayment(terminalPayload);
          this.showTerminalBusyDialog = true;
        } else {
          this.messageService.add({ severity: 'error', summary: 'Terminal payment failed', detail });
          this.paymentButtonLocked = false;
        }
      }
    }, () => {
      this.messageService.add({ severity: 'error', summary: 'Terminal payment failed', detail: 'Could not initiate terminal payment.' });
      this.paymentButtonLocked = false;
    });
  }

  waitForTerminal(): void {
    this.showTerminalBusyDialog = false;
  }

  clearTerminalAndRetryPayment(): void {
    const terminalId = this.pendingTerminalPayload?.terminalId ?? '';
    this.showTerminalBusyDialog = false;
    this.http.get<any>(bmxurl + 'StripeTerminalCancel/' + this.VenueID + '/' + terminalId).subscribe({
      complete: () => {
        this.pendingTerminalRetry?.();
      }
    });
  }

  cancelTerminalPayment(): void {
    this.terminalPaymentResolved = true;
    this.stopTerminalPolling();

    if (this.terminalHubConnection) {
      this.terminalHubConnection.stop();
      this.terminalHubConnection = null;
    }

    const terminalId = localStorage.getItem(`GeneralTerminalName_${this.VenueID}`) ?? '';
    this.http.get<any>(bmxurl + 'StripeTerminalCancel/' + this.VenueID + '/' + terminalId).subscribe({
      complete: () => {
        this.awaitingTerminalPayment = false;
        this.paymentButtonLocked = false;
      }
    });
  }

  sendSMSConfirmation(){
     this.http.get<customer>(bmxurl + "confirmation/" + this.VenueID + "/" + this.thisMembershipSale.saleid).subscribe(response => {
       this.messageService.add({severity:'success', summary:'Success', detail:'SMS Message sent.'});
     }, error => {
       this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send the SMS'});
     })
  }

  sendEmailConfirmation(){
     this.http.get<customer>(bmxurl + "confirmationemail/" + this.VenueID + "/" + this.thisMembershipSale.saleid).subscribe(response => {
       this.messageService.add({severity:'success', summary:'Success', detail:'Email Message sent.'})
     }, error => {
       this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send the Email'});
     })
  }

  returnHome(){
    this.BookingPayments = [];
    this.totalPayments = 0;

    this.checked = [];

    this.BookingComplete = false;

    this.PackageHeader = "Select a Package";
    this.CalendarHeader = "Select a Date";
    this.AdmissionHeader = "Select your Admissions";
    this.TimeHeader = "Select a Time";
    this.CustomerHeader = "Create a Customer";
    this.PaymentHeader = "Add a Payment";
    this.ExtrasHeader = "Select Extras";

    this.startTimes = null;
    this.startTimesFiltered = null;

    this.SelectedPackage = null;
    this.SelectedDate = null;

    this.firstName = "";
    this.lastName = "";
    this.address1 = "";
    this.address2 = "";
    this.town = "";
    this.postCode = "";
    this.email = "";
    this.mobile = "";
    this.searchCriteria = "";
    this.customersResult = null;
    this.ShowCustomerDetails = false;

    this.selectedPayment = null;
    this.packageExtras = null;
    this.paymentAmount = 0;
    this.makeABookingHeader = "Make a Booking";
    this.thisMembershipSale = {} as membershipsale;
    this.customerSelectedResources = [];
    this.SelectedResources = [];

    this.MinimumValidPayment = 0;

    this.ViewMemberships = true;
    this.ViewAdmissions = false;
    this.ViewDetails = false;
    this.ViewCustomer = false;
    this.ViewPayment = false;

    this.admissionsMaxReached = false;
    this.admissionsMaxReachedMessage = '';

    this.chosenMembership = null;
    this.MembershipAdmissions = [];
    this.SelectedAdmissions = [];
    this.DetailedMembershipAdmissions = [];
    this.validname = [];
    this.validdob = [];
    this.validdobinpast = [];
  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  addMs = (date: Date, ms: number): Date => {
    const result = new Date(date);
    result.setMilliseconds(result.getMilliseconds() + ms);
    return result;
  };

  printConfirmation()
  {
    this.showPrintConfirmations = true;
    this.http.get(bmxurl + "print/" + this.VenueID + "/" + this.thisMembershipSale.saleid).subscribe(response => {
      this.confHTML = (response as conf_returndata).data.toString();
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Payment Types.'});
    })

  }

}



